import React from "react";
import { Typography, Stack, Box } from "@mui/material";
import { Link } from "react-router-dom";

interface ProduceCommoditiesProps {
  itemId?: string;
  description?: string;
}

const ProduceCommodities: React.FC<ProduceCommoditiesProps> = ({
  itemId,
  description
}) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "row", gap: "10px" }}>
      <Stack
        direction="row"
        textTransform={"uppercase"}
        alignItems="start"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          alignContent: "start"
        }}
      >
        <Stack direction="row" alignItems="center" gap={"4px"}>
          <Link to={`/product/${itemId}`} aria-label={"product"}>
            <Typography color="primary.main" fontSize={14}>
              {itemId.toString().replace(/^0+/, "")}
            </Typography>
          </Link>
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          spacing={"4px"}
          sx={{ flexGrow: 1 }}
        >
          <Typography
            color="grey.900"
            fontSize={14}
            textTransform="capitalize"
            title={description}
            sx={{
              width: "200px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              cursor: "default"
            }}
          >
            {description}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default ProduceCommodities;
